'use strict';

global.cookieManager = require('../cookieManager.js');
